<template>
  <div class="">
    <div
      class="payment-condition__icon__title__ref d-flex caption-strong align-items-center gap-1"
    >
      <p
        class="payment-condition-icon d-flex align-items-center gap-1 m-0"
        :class="[props.borderClass, props.textClass, props.backgroundClass]"
      >
        <span class="d-flex align-items-center">
          <slot name="payment-condition-icon"> </slot>
        </span>
        <span>
          <slot name="payment-condition-type"></slot>
        </span>
      </p>
      <p class="payment-condition__title__ref m-0">
        <slot name="payment-condition__title__ref"></slot>
      </p>
    </div>
    <p class="payment-condition-description m-0 mt-1 caption">
      <slot name="payment-condition-description"></slot>
    </p>
    <div v-if="$slots['terms-and-conditions']" class="mt-1">
      <slot name="terms-and-conditions"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps } from 'vue'

  interface Props {
    borderClass: string
    textClass: string
    backgroundClass?: string
  }

  const props = defineProps<Props>()
</script>

<style scoped>
  .payment-condition-icon {
    border-radius: 3px;
    padding: 5px;
    height: 20px;
    min-width: 50px;
  }

  .orange-border {
    border: 1px solid var(--primary-orange);
  }

  .blue-border {
    border: 1px solid var(--primary-blue);
  }
</style>
